import {
	COL_ORDER as TABLE_GRID_COL_ORDER,
	LISTED_SELECTED_CONTACTS as SET_SELECTED_CONTACTS,
	LISTED_UNSELECTED_CONTACTS as SET_UNSELECTED_CONTACTS,
	SORT_CHANGED as SET_SORT_CHANGED,
	RESET_TABLE_GRID_COL_ORDER,
	SELECT_ALL_CHANGED as SET_SELECT_ALL,
	SELECT_ALL_PAGES_CHANGED,
} from "./actions";

let initialState = () => {
	return {
		sortChanged: false,
		selectedContacts: [],
		selectAllChecked: false,
		selectAllPagesChecked: false,
		tableColOrder: [
			{
				name: "email",
				isAttribute: false,
				i18n: "app-general-email" ,
				type: "text",
				sortTooltip : false,
			},
			{
				name: "subscribed_on",
				isAttribute: false,
				i18n:
					"app-contacts-segments-creation-DL-created_date"
				,
				type: "timestamp",
				sortTooltip : false,
			},
			{
				name: "status",
				isAttribute: false,
				i18n: "app-contact-status" ,
				type: "text",
			},
			{
				name: "bounces_count",
				isAttribute: false,
				i18n: "app-contact-bounce-count",
				type: "text",
			},
			{
				name: "last_bounce_type",
				isAttribute: false,
				i18n: "app-contact-last-bounce-type",
				type: "text",
			},
			{
				name: "tags",
				isAttribute: false,
				i18n: "app-general-tags",
				type: "array",
			},
			{
				name: "interests",
				isAttribute: false,
				i18n: "app-list-manage-interests-title",
				type: "array",
			},
		],
	};
};

export const reducer = (state = initialState(), action) => {
	switch (action.type) {
	case SET_SELECTED_CONTACTS:
		return { ...state, selectedContacts: action.selectedContacts };
		break;
	case SET_UNSELECTED_CONTACTS:
		return { ...state, unSelectedContacts: action.unSelectedContacts };
		break;
	case TABLE_GRID_COL_ORDER:
		return { ...state, tableColOrder: action.tableColOrder };
		break;
	case RESET_TABLE_GRID_COL_ORDER:
		return { ...state, tableColOrder: initialState().tableColOrder };
		break;
	case SET_SORT_CHANGED:
		return { ...state, sortChanged: action.sortChange };
		break;
	case SET_SELECT_ALL:
		return { ...state, selectAllChecked: action.selectAllChecked };
		break;
	case SELECT_ALL_PAGES_CHANGED:
		return { ...state, selectAllPagesChecked: action.selectAllPages };
		break;
	default:
		return state;
		break;
	}
};
